var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { TeamsMeetingCandidate } from "../../../components/meeting-gui-candidate";
import { useApplicationContext } from "../../../context/application-context";
import apiClientServices, { setAuthorization } from "../../../api-client";
import { MEETING_ENDPOINTS } from "../../../utils/endpoints";
import { decryptText } from "../../../utils/encrypt-decrypt";
import { applyManagerLoginToContext, hydrateManagerUserFromStorage, } from "../../../utils/manager-login-profile";
import HiringFeedbackV2 from "../../../components/hiring-feedback-v2";
import HmMeetingShell from "../hm-meeting-shell";
import { messages } from "../../../submodules/Inventory-Module-Types/src";
const ManagerMeetingUrlBasedWithoutMsLogin = () => {
    var _a, _b;
    const [searchParams] = useSearchParams();
    const { user, setUser, tenantSettings } = useApplicationContext();
    const [acsToken, setAcsToken] = useState(null);
    const [meetingLink, setMeetingLink] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [decryptedPayload, setDecryptedPayload] = useState(null);
    const [hideFeedbackForm, setHideFeedbackForm] = useState(false);
    const colorPalette = (_a = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.tenantConfig) === null || _a === void 0 ? void 0 : _a.colorPalette;
    const spinnerIndicator = useMemo(() => (_jsx(LoadingOutlined, { style: {
            fontSize: 48,
            color: (colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor) || "#1890ff",
        }, spin: true })), [colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor]);
    // Function to decrypt and extract meeting data from link parameter
    const decryptMeetingData = () => {
        try {
            let link = searchParams.get("link");
            if (!link) {
                // Try to get from sessionStorage (stored during login init)
                return null;
            }
            if (link) {
                console.log("link in decryptMeetingData:", link);
                // Replace spaces with + (URL encoding)
                link = link.replaceAll(" ", "+");
                // Decrypt the link using the encryption key
                const encryptionKey = process.env.REACT_APP_PUBLIC_FEEDBACK_BIG;
                if (!encryptionKey) {
                    console.error("Encryption key not found in environment variables");
                    return null;
                }
                const stringPayload = decryptText(link, encryptionKey);
                if (!stringPayload) {
                    console.error("Failed to decrypt link");
                    return null;
                }
                const jsonPayload = JSON.parse(stringPayload);
                console.log("jsonPayload in decryptMeetingData:", jsonPayload);
                return jsonPayload;
            }
        }
        catch (error) {
            console.error("Error decrypting meeting data:", error);
        }
        return null;
    };
    // Function to fetch meeting link from API
    const getMeetingUrl = (decryptedData) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        try {
            setAuthorization(sessionStorage.getItem("token"));
            // Extract userId, courseId, and stageId from decrypted payload
            // The payload might have uid/cid/sid (decoded) or userId/courseId/stageId (decoded)
            const userId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.userId;
            const courseId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.courseId;
            const stageId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.stageId;
            const hmId = sessionStorage.getItem("userId");
            if (userId && stageId && courseId) {
                console.log("userId, stageId, courseId, hmId in getMeetingUrl:", userId, stageId, courseId, hmId);
                const response = yield apiClientServices.get(MEETING_ENDPOINTS.GET_HM_MEETING_LINK, {
                    params: Object.assign({ userId: userId.toString(), stageId: stageId.toString(), courseId: courseId.toString() }, (hmId && { hmId: hmId.toString() })),
                });
                if ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.meetLink) {
                    setHideFeedbackForm(response.data.result.selectBotInterviewStageOnCaseStudyInvite ===
                        true);
                    return response.data.result.meetLink;
                }
            }
        }
        catch (error) {
            console.error("Error fetching meeting link from API:", error);
        }
        // Fallback to meetingLink from decrypted data if API fails
        return (decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.ml) || (decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.meetingLink) || null;
    });
    const getAcsToken = (accessToken) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield axios({
            method: "GET",
            url: `${MEETING_ENDPOINTS.GET_ACS_TOKEN}`,
            headers: {
                Authorization: "Bearer " + accessToken,
            },
        });
        const data = response === null || response === void 0 ? void 0 : response.data;
        return (typeof data === "string" ? data : data === null || data === void 0 ? void 0 : data.token) || null;
    });
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const getOrCreateAppAccessToken = (decryptedData, email) => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f;
        const existingToken = sessionStorage.getItem("token");
        if (existingToken) {
            hydrateManagerUserFromStorage(setUser);
            return existingToken;
        }
        if (!email || !isValidEmail(email)) {
            throw new Error("Valid email is required in query params.");
        }
        const tenantId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.tenantId;
        if (!tenantId) {
            throw new Error("Tenant not found in meeting link payload.");
        }
        const emailPrefix = email.split("@")[0] || "manager";
        const requestData = {
            channelType: "Google",
            profileObj: {
                email,
                familyName: "",
                givenName: emailPrefix,
                name: emailPrefix,
                googleId: email,
            },
            meetingData: decryptedData,
            tenantId,
        };
        const response = yield apiClientServices({
            method: "POST",
            url: "/connect/login",
            data: requestData,
            headers: Object.assign(Object.assign({}, apiClientServices.defaults.headers.common), { tid: tenantId }),
        });
        const responseLocal = (_e = response.data) === null || _e === void 0 ? void 0 : _e.result;
        if (!(responseLocal === null || responseLocal === void 0 ? void 0 : responseLocal.access_token) || !(responseLocal === null || responseLocal === void 0 ? void 0 : responseLocal.user_id)) {
            throw new Error("Failed to create manager session.");
        }
        sessionStorage.setItem("token", responseLocal.access_token);
        sessionStorage.setItem("userId", responseLocal.user_id.toString());
        sessionStorage.setItem("email", responseLocal.email);
        sessionStorage.setItem(messages.SESSION_INTERVIEW_META_DATA, JSON.stringify({
            token: responseLocal.access_token,
            userId: responseLocal.user_id.toString(),
            app: (_f = responseLocal === null || responseLocal === void 0 ? void 0 : responseLocal.tenant) === null || _f === void 0 ? void 0 : _f.assessmentLink,
        }));
        setAuthorization(responseLocal.access_token);
        applyManagerLoginToContext(responseLocal, setUser);
        return responseLocal.access_token;
    });
    useEffect(() => {
        const initializeMeeting = () => __awaiter(void 0, void 0, void 0, function* () {
            // Decrypt meeting data from link parameter
            const decryptedData = decryptMeetingData();
            if (!decryptedData) {
                setError("Invalid or missing meeting link. Please check the URL.");
                setIsLoading(false);
                return;
            }
            const emailParam = searchParams.get("email");
            // Fetch meeting link from API using decrypted data
            try {
                setDecryptedPayload(decryptedData);
                const appAccessToken = yield getOrCreateAppAccessToken(decryptedData, emailParam);
                const [meetingUrl, managerAcsToken] = yield Promise.all([
                    getMeetingUrl(decryptedData),
                    getAcsToken(appAccessToken),
                ]);
                if (!meetingUrl) {
                    setError("Meeting link not found. Please check the URL parameters.");
                    return;
                }
                if (!managerAcsToken) {
                    setError("Failed to get meeting token. Please try again.");
                    return;
                }
                setMeetingLink(meetingUrl);
                setAcsToken(managerAcsToken);
            }
            catch (err) {
                console.error("Error initializing meeting:", err);
                setError("Failed to load meeting. Please try again.");
            }
            finally {
                setIsLoading(false);
            }
        });
        initializeMeeting();
    }, [searchParams]);
    const handleMeetingEnd = () => {
        // Clean up meeting-related temporary params
        sessionStorage.removeItem("manager_meeting_link");
        sessionStorage.removeItem("manager_meeting_link_param");
        console.log("Meeting ended");
    };
    if (isLoading) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx(Spin, { size: "large", indicator: spinnerIndicator }), _jsx("div", Object.assign({ style: { marginTop: 16 } }, { children: "Loading meeting..." }))] })));
    }
    if (error) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx("div", Object.assign({ style: { color: "red", marginBottom: 16 } }, { children: error })), _jsx("button", Object.assign({ onClick: () => window.location.reload() }, { children: "Retry" }))] })));
    }
    if (!acsToken || !meetingLink) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx("div", Object.assign({ style: { marginBottom: 16 } }, { children: "Missing required information. Please try again." })), _jsx("button", Object.assign({ onClick: () => window.location.reload() }, { children: "Retry" }))] })));
    }
    return (_jsx(HmMeetingShell, { hideFeedbackForm: hideFeedbackForm, meeting: _jsx(TeamsMeetingCandidate, { userId: { communicationUserId: "" }, token: acsToken, locator: meetingLink, displayName: user ? `${user.firstName} ${user.lastName}` : "Manager", callInvitationURL: meetingLink, onMeetingEnd: handleMeetingEnd }), feedback: _jsx(HiringFeedbackV2, { userId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.userId, courseId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.courseId, stageId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.stageId, panelInterviewId: (_b = decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.panelInterviewId) !== null && _b !== void 0 ? _b : decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.interviewId, enableInviteAdditionalHm: true }) }));
};
export default ManagerMeetingUrlBasedWithoutMsLogin;
